import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { CustomCard } from "../../../../../Components";

import useStyles from "./styles";

function LastActivitySkeletonLoader() {
  const styles = useStyles();

  return (
    <CustomCard
      classes={styles.cardStyle}
      boxShadow="xs"
      borderRadius="xl"
      borderColor="secondary"
    >
      <Box
        className={styles.contentWrapper}
        display="flex"
        flexDirection="row"
        flexWrap={"wrap"}
        gridGap={"16px"}
        bgcolor="background.paper"
      >
        <Box className={styles.summaryField}>
          <Skeleton variant="text" width="90px" height={40} />
          <Skeleton variant="text" width="90%" height={55} />
        </Box>
        <Box className={styles.summaryField}>
          <Skeleton variant="text" width="90px" height={40} />
          <Skeleton variant="text" width="90%" height={55} />
        </Box>
        <Box className={styles.summaryField}>
          <Skeleton variant="text" width="90px" height={40} />
          <Skeleton variant="text" width="90%" height={55} />
        </Box>
      </Box>
    </CustomCard>
  );
}

export default LastActivitySkeletonLoader;
